"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTable = exports.tableContext = void 0;
var react_1 = require("react");
exports.tableContext = react_1.createContext(null);
function useTable() {
    var context = react_1.useContext(exports.tableContext);
    if (context == null) {
        throw Error('Oops, you should use `useTable` in Table.');
    }
    return context;
}
exports.useTable = useTable;
//# sourceMappingURL=hooks.js.map